"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toast = exports.status = exports.reputation = exports.chart = void 0;
const YamaColors_1 = __importDefault(require("./YamaColors"));
// Chart colors are not in the Yama color palette,
// but are part of the Sumo Dashboards color palettes.
exports.chart = {
    blue: '#1677B6',
    blueLight: '#A5CEE4',
    purple: '#CAB1D7',
    purpleDark: '#6B399C',
    turquoise: '#65AAA3',
    green: '#2CA221',
    yellow: '#FFC068',
    yellowDark: '#E8BF39',
    orange: '#FF7F00',
    red: YamaColors_1.default['critical-70'],
    grey: YamaColors_1.default['black-20'],
    greyDark: YamaColors_1.default['black-90'],
};
exports.reputation = {
    malicious: YamaColors_1.default['critical-60'],
    notflagged: YamaColors_1.default['grey-30'],
    suspicious: YamaColors_1.default['warning-40'],
};
exports.status = {
    critical: YamaColors_1.default['critical-70'],
    high: YamaColors_1.default['critical-50'],
    medium: YamaColors_1.default['warning-40'],
    low: YamaColors_1.default['ocean-40'],
};
exports.toast = {
    default: YamaColors_1.default['black-60'],
    success: YamaColors_1.default['success-60'],
    warning: YamaColors_1.default['warning-60'],
    error: YamaColors_1.default['critical-60'],
    info: YamaColors_1.default['primary-60'],
};
